// extracted by mini-css-extract-plugin
export var deliveryRow = "_mz-a";
export var fixedHeight = "_mz-4";
export var freightLogo = "_mz-9";
export var fullWidth = "_mz-3";
export var priceColumn = "_mz-5";
export var radioSelected = "_mz-7";
export var radioUnselected = "_mz-6";
export var selectedOption = "_mz-2";
export var selectedOptionContainer = "_mz-1";
export var selection = "_mz-0";
export var tallSkeletonText = "_mz-8";